<template>
  <EntityList
    ref="activeList"
    :config="config"
    :columns="columns"
    :custom-query="{ requestType: parentEntity.id }"
    :formatted-columns="formattedColumns"
    :form-fields="formFields"
    authority="Request_Type_Management_Request_Type"
    embedded
    @entityUpdated="updateEntity"
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import storeModule from './sectionGroupsStoreModule'

export default {
  components: {
    EntityList,
  },
  props: {
    module: {
      type: String,
      required: true,
    },
    parentEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      entity: {},
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'request-type-section-groups',
        endpoint: 'request-type-section-groups',
        route: 'request-type-section-groups',
        title: {
          single: this.$t('Section Group Add'),
          plural: this.$t('Section Groups'),
        },
      }
    },
    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('title'), sortable: true },
        { key: 'ordering', label: this.$t('ordering'), sortable: true },
        {
          key: 'creationDate',
          label: this.$t('Creation Date'),
          sortable: true,
        },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [{ key: 'creationDate', type: 'datetime' }]
    },
    formFields() {
      return [
        {
          id: 'requestType',
          type: 'hidden',
          initVal: { id: this.parentEntity.id },
          hidden: true,
        },
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
        },
        {
          id: 'description',
          type: 'quill',
          label: this.$t('description'),
          required: false,
        },
        {
          id: 'ordering',
          type: 'text',
          label: this.$t('ordering'),
          required: true,
          rules: 'integer',
          initVal: 1,
          colSize: 6,
        },
        {
          id: 'visible',
          type: 'checkbox',
          label: this.$t('Visible'),
          initVal: true,
          colSize: 6,
        },
      ]
    },
  },
  mounted() {
    this.loaded = true
  },
  methods: {
    updateEntity(newEntity) {
      this.entity = newEntity
    },
  },
}
</script>
